if (!customElements.get('dd-campaign-hero')) {
  customElements.define('dd-campaign-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.dd-campaign__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pause = this.querySelector('.dd-campaign__pause');
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-slide]');
        const arrow = event.target.closest('[data-direction]');
        if (dot) this.show(Number(dot.dataset.slide));
        if (arrow) this.show(this.index + Number(arrow.dataset.direction));
        if (event.target.closest('.dd-campaign__pause')) {
          this.paused = !this.paused;
          this.syncPause();
        }
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.schedule(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => this.schedule(), options);
      this.addEventListener('touchstart', event => {this.touchX = event.touches[0].clientX; this.stop();}, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        const distance = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(distance) > 50) this.show(this.index + (distance < 0 ? 1 : -1));
        this.schedule();
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target);
        if (index >= 0) {this.paused = true; this.syncPause(); this.show(index); this.stop();}
      }, options);
      this.syncPause();
      this.schedule();
    }
    disconnectedCallback() {this.stop(); this.events?.abort();}
    syncPause() {
      if (!this.pause) return;
      this.pause.textContent = this.paused ? 'Play' : 'Pause';
      this.pause.setAttribute('aria-label', this.paused ? 'Play banner rotation' : 'Pause banner rotation');
      this.pause.setAttribute('aria-pressed', String(this.paused));
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {slide.hidden = i !== this.index; slide.inert = i !== this.index;});
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    }
    stop() {clearTimeout(this.timer);}
    schedule() {
      this.stop();
      if (this.paused || document.hidden || this.slides.length < 2 || this.matches(':hover') || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => {this.show(this.index + 1); this.schedule();}, Number(this.dataset.interval) || 7000);
    }
  });
}
